import { usePostLifeInsuranceData } from "hooks/data/usePostLifeInsuranceData"
import React from "react"

export type FactFindContextProps = ReturnType<typeof usePostLifeInsuranceData>

export const context = React.createContext({} as FactFindContextProps)
